Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultConfiguration = void 0;
var _HostUri = require("../HostUri");
var _HostUri$concat;
var DefaultConfiguration = exports.DefaultConfiguration = {
  ApiNamespace: '/api/v2',
  BaseUrl: (_HostUri$concat = _HostUri.HostUri == null ? void 0 : _HostUri.HostUri.concat(":3000")) != null ? _HostUri$concat : 'http://localhost:3000',
  ClientApplication: 'clarity'
};